<crm-multi-select
  #multiSelectComponent
  [options]="companies"
  [(selectedItems)]="selectedCompanies"
  (selectedItemsChange)="onSelectedCompaniesChange($event)"
  [label]="isFloatLabel ? label : ''"
  [virtualScroll]="true"
  [virtualScrollItemSize]="33"
  scrollHeight="300px"
  [styleClass]="styleClass + (isError ? ' ng-invalid ng-dirty' : '')"
  [class]="class + (isError ? ' ng-invalid ng-dirty' : '')"
  [showClear]="showClear"
  [appendTo]="appendTo"
  [disabled]="disabled"
  [display]="display"
  [sort]="sort"
  [placeholder]="placeholder"
  [itemStyleClass]="itemStyleClass"
  [filtersUiVersion]="filtersUiVersion"
  [lazy]="!customRequest"
  [loading]="selectionLoading"
  (onLazyLoad)="loadMoreCompanies($event)"
  (onFilter)="filterCompanies($event)">
  <ng-template
    #itemTemplate
    let-company="item">
    @if (toCompany(company); as company) {
      <div class="flex align-items-center gap-2">
        <div [ngClass]="itemStyleClass">
          <span [innerHTML]="highlightMatchText(company.name) | safeHtml"></span>
        </div>
        @if (company.deleted) {
          <div class="font-medium text-red-500">(Удалена)</div>
        }
      </div>
    }
  </ng-template>
</crm-multi-select>
